export default "__VITE_ASSET__CVDsA6vK__"